import styled from 'styled-components'

export const Hr = styled.hr`
  color: #ececec;
`



// WEBPACK FOOTER //
// ./src/elements/Hr.ts